(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dear-privacy"] && !Shopify.designMode) return;
  try {
    (() => {
  let attempts = 0;
  const exposePreferences = () => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return false;
    document.querySelectorAll('.dp-cookie-settings').forEach(button => { button.hidden = false; });
    return true;
  };
  if (!exposePreferences()) {
    const timer = setInterval(() => {
      if (exposePreferences() || ++attempts >= 40) clearInterval(timer);
    }, 250);
  }
  document.addEventListener('shopify:section:load', exposePreferences);
  document.addEventListener('click', event => {
    const button = event.target.closest('.dp-cookie-settings');
    if (!button || typeof window.privacyBanner?.showPreferences !== 'function') return;
    window.privacyBanner.showPreferences().catch(() => { button.hidden = true; });
  });
  // Keep Shopify's consent actions; only make its first-visit banner modal.
  let activeBanner = null;
  let wasOpen = false;
  let previousFocus = null;
  const bannerObserver = new MutationObserver(syncCookieModal);
  function visible(element) {
    return !!element && !element.hidden && element.getAttribute('aria-hidden') !== 'true' &&
      getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden';
  }
  function syncCookieModal() {
    const banner = document.getElementById('shopify-pc__banner');
    if (banner !== activeBanner) {
      bannerObserver.disconnect();
      activeBanner = banner;
      if (banner) bannerObserver.observe(banner, {attributes:true, attributeFilter:['style','hidden','aria-hidden']});
    }
    const open = visible(banner);
    document.documentElement.classList.toggle('dp-cookie-modal-open', open);
    if (banner) banner.setAttribute('aria-modal', String(open));
    if (open && !wasOpen) {
      previousFocus = document.activeElement;
      const title = banner.querySelector('#shopify-pc__banner__body-title');
      const target = title || banner;
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
    } else if (!open && wasOpen && previousFocus?.isConnected) {
      previousFocus.focus?.({preventScroll:true});
    }
    wasOpen = open;
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !wasOpen || !activeBanner) return;
    // Let Shopify's own preferences dialog manage its focus when it is open.
    if (visible(document.getElementById('shopify-pc__prefs'))) return;
    const controls = [...activeBanner.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')]
      .filter(element => visible(element) && element.getClientRects().length);
    if (!controls.length) return;
    const first = controls[0], last = controls[controls.length - 1];
    const current = document.activeElement;
    if (event.shiftKey && (current === first || !controls.includes(current))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (current === last || !activeBanner.contains(current))) {
      event.preventDefault(); first.focus();
    }
  });
  new MutationObserver(syncCookieModal).observe(document.body, {childList:true});
  syncCookieModal();
})();
  } catch(e) { console.error(e); }
})();

})();
